<template>
    <v-container>
      <v-container>
        <v-row>
      <v-col cols="3">
          <v-autocomplete
            v-model="criteriaState.groupCode"
            :items="groupCodes"
            id="investmentGroupCodeFilter"
            class="investment-group-code-filter"
            label="By Group Code"
            clearable
            @change="searchByCriteria"
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
           <v-autocomplete
           v-model="criteriaState.bank"
           :items="groupCodebankDesc"
            id="collateralBankBankNameText"
            class="collateral-bank-trans-item-bank-name-text"
            label="By Bank"
            item-text="groupCodeBankDesc"
            item-value="_id"
            @change="searchByCriteria"
          ></v-autocomplete>
        </v-col>
        <v-col cols="3" class="d-flex align-center">
          <v-checkbox
            v-model="showHidden"
            label="Show Hidden"
            hide-details
            class="mt-0 pt-0"
            @change="searchByCriteria"
          ></v-checkbox>
        </v-col>
      </v-row>
      </v-container>
          <CRUDList
            ref="crudListInvestment"
            :canAdd="true"
            :headers='headers'
            :displayTopPagination="false"
            :canEdit="true"
            :canSave="saveable"
            :showDate="false"
            :showTotal="true"
            :baseCrudKey="baseCrudKey"
            :createNewItem="newItemDialog"
            @onSingleClicked="handleSingle"
            @loadCRUDList="handleLoadCRUDList"
            @upsertItem="upsertTransaction"
            :defaultSortBy="sortBy"
            @emitSelectedItem="emitSelectedItem"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table'
            tableDynamicHeight='250'
            :enableFixedHeaders="true"
           >
            <template v-slot:[`editedItem`]="{}">
              <InvestmentEditedItem
              :baseCrudKey="baseCrudKey"
              @activeItem="activeItem"
              @upsertInvestment="handleUpsertInvesment"
              :isValidForm="isValidForm"
              />
            </template>
            <template v-slot:[`additionalActions`]="{}">
        <span  v-if="!isNewItem()">
          <v-btn :class="`input-text-size`"
            text color="blue darken-1"
            :disabled="editedItem.isClosed"
            @click="deleteInvestment"
            >Delete</v-btn>
        </span>
      </template>
          </CRUDList>
          <CRUDList
            ref="crudList"
            :canAdd="false"
            :headers='headersTable'
            :displayTopPagination="false"
            :canEdit="false"
            :canSave="false"
            :baseCrudKey="baseCrudKeyBelow"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table'
            tableDynamicHeight='250'
            :enableFixedHeaders="true"
           >
          </CRUDList>
        </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
  mapMutations,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import InvestmentEditedItem from './InvestmentsEditedItem.vue';
import { amountToNumber, extractId } from '../../../util/shared/vue-global';
import { toShortDate, toIsoDate } from '../../../util/shared/tmc-global';
import isInterestLikeEntryType from './investmentEntryType.util';

const formatAmountOrNull = (val) => {
  const amount = `${val} %`;
  return amount;
};
function valueType(val) {
  switch (val) {
    case 'TNOTE':
      return 'T-Note';
    case 'MONEYMARKET':
      return 'MONEY MARKET';
    case 'MUTUALFUND':
      return 'MUTUAL FUND';
    case 'BROKEREDCD':
      return 'BROKERED CD';
    default:
      return val;
  }
}
const getHeaders = () => {
  const headers = [
    { text: 'Investment ID#', value: 'investmentId' },
    {
      text: 'Type',
      value: 'type',
      formatter: 'customMethod',
      methodDefinition: valueType,
    },
    { text: 'Investment #', value: 'investmentNumber' },
    { text: 'Purchase Date', value: 'purchaseDate' },
    { text: 'Maturity Date', value: 'maturityDate' },
    { text: 'Days', value: 'diffInDays' },
    {
      text: 'Interest Rate',
      value: 'interestRate',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    { text: 'GL Fund', value: 'fund.fund' },
    { text: 'Group Code', value: 'groupCode' },
    { text: 'Bank Name', value: 'bank.bankName' },
    {
      text: 'Original Principal', value: 'principalAmount', formatter: 'amount', align: 'right',
    },
    {
      text: 'Interest Paid', value: 'interestAmount', formatter: 'amount', align: 'right',
    },
  ];
  return headers;
};

const getHeadersTable = () => {
  const headers = [
    { text: 'Date', value: 'date' },
    { text: 'Original Principal', value: 'entryType', align: 'center' },
    {
      text: 'Amount', value: 'amount', formatter: 'amount', align: 'right',
    },
    {
      text: 'Receipted?', value: 'isReceipt', formatter: 'boolToStr', align: 'center',
    },
    { text: 'Description', value: 'description' },
  ];
  return headers;
};
export const postProcessInve = (transactions) => transactions.map((transaction) => {
  const newTransaction = { ...transaction };

  if (newTransaction.maturityDate) {
    newTransaction.maturityDate = toShortDate(transaction.maturityDate);
  } else {
    newTransaction.maturityDate = 'NONE';
  }
  newTransaction.purchaseDate = toShortDate(transaction.purchaseDate);
  newTransaction.interestRate = parseFloat((transaction.interestRate || 0).toFixed(6));

  let interestAmount = 0;
  let principalAmount = 0;
  let diffInDays = 0;

  const { details, maturityDate, purchaseDate } = transaction;

  if (maturityDate && purchaseDate) {
    const maturityDateObj = new Date(maturityDate);
    const purchaseDateObj = new Date(purchaseDate);

    // Ensure both dates are valid using Number.isNaN
    if (!Number.isNaN(maturityDateObj) && !Number.isNaN(purchaseDateObj)) {
      const timeDiff = maturityDateObj - purchaseDateObj;
      diffInDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    }
  }
  // Calculate the interest and principal amounts from details
  (details || []).forEach((detail) => {
    if (isInterestLikeEntryType((detail || {}).entryType)) {
      interestAmount += detail.amount;
    } else if ((detail || {}).entryType === 'PRINCIPAL') {
      principalAmount += detail.amount;
    }
  });

  return {
    ...newTransaction,
    interestAmount,
    principalAmount,
    diffInDays,
  };
});

const bankCrudKey = 'sharedBank';

export default {
  name: 'InvestmentList',
  components: {
    CRUDList,
    InvestmentEditedItem,
  },
  data: () => ({
    baseCrudKey: 'investments',
    baseCrudKeyBelow: 'investmentBelow',
    headers: [],
    sortBy: [
      {
        column: 'investmentId',
        direction: 'asc',
      },
    ],
    saveable: true,
    isValidForm: false,
    todaysDate: new Date(),
    showHidden: false,
  }),
  created() {
    this.headers = getHeaders();
    this.headersTable = getHeadersTable();
    this.loadBanks({
      criteria: {},
      baseCrudKey: bankCrudKey,
    });
    this.loadGLCollateralBankTrans({ criteria: {}, baseCrudKey: 'GroupCodeDropdown' });
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
      'items',
      'index',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.glDaily.glInvestmentTransaction.selectedItems,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    banks() {
      const bankObjs = this.items(bankCrudKey) || [];
      return [{ _id: null, bankName: '' }, ...bankObjs];
    },
    groupCodebankDesc() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObjs = bankObjs.map((b) => ({
        ...b,
        groupCodeBankDesc: b.groupCode ? `${b.groupCode} - ${b.bankName}` : b.bankName,

      }));
      return [{ _id: null, groupCodeBankDesc: '' }, ...updatedBankObjs];
    },
    groupCodes() {
      const bankObjs = this.items(bankCrudKey) || [];
      const unique = [...new Set(bankObjs.map((b) => b.groupCode).filter(Boolean))];
      return unique.sort();
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem', 'setItems']),
    ...mapActions('glDaily/glInvestmentTransaction', [
      'upsertInvestmentTrans',
      'loadInvestmentDetailsTrans',
      'delinvestmentTran',
    ]),
    ...mapActions('glDaily/glInvestmentTransaction', [
      'loadLastInvestmentNo',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('glDaily/glCollateralBankTransaction', [
      'loadGLCollateralBankTrans',
    ]),
    emitSelectedItem(item) {
      this.selectedItems = item;
    },
    searchByCriteria() {
      this.handleLoadCRUDList();
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    handleUpsertInvesment() {
      const isValidForm = this.$refs.crudListInvestment.$refs.crudDialog.validateForm();
      this.isValidForm = isValidForm;
      if (!isValidForm) return;
      this.upsertTransaction();
    },
    activeItem(item) {
      if (item.isLocked === true) {
        this.saveable = false;
        return this.saveable;
      }
      this.saveable = true;
      this.activeTransItem = item;
      return this.saveable;
    },
    handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = this.criteria(baseCrudKey);
      delete criteria.fiscalYear;
      const { showHidden } = this;
      const filterHidden = (transactions) => {
        const processed = postProcessInve(transactions);
        if (showHidden) return processed;
        return processed.filter(
          (t) => t.isHidden !== true,
        );
      };
      this.loadInvestmentDetailsTrans({
        criteria,
        baseCrudKey,
        postProcessTrans: filterHidden,
      });
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        investmentId: null,
        purchaseDate: null,
        maturityDate: null,
        type: '',
        investmentNumber: null,
        interestRate: '',
        groupCode: '',
      };
      this.loadLastInvestmentNo();
      return newItem;
    },
    handleSingle(item) {
      const updatedDetails = (item.details || []).filter(Boolean).map((detail, i) => ({
        ...detail,
        date: toShortDate(detail.date),
        index: i,
      }));
      this.setItems([this.baseCrudKeyBelow, updatedDetails]);
    },

    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    async upsertTransaction() {
      const { bank, groupCode } = this.editedItem;
      if (bank) {
        const selectedBank = this.banks.find((b) => b._id === bank);
        // Confirm if group code is missing
        if (selectedBank) {
          if (groupCode === null && !window.confirm(`This record is missing a group code for "${selectedBank.bankName || ''}" Gl bank. Do you wish to proceed?`)) {
            this.editFeesDialog = false;
            return null; // Exit if user cancels
          }
        }
      }
      const itemData = this.item(this.baseCrudKey);
      const updatedItem = { ...itemData };
      updatedItem.investmentId = amountToNumber(updatedItem.investmentId);
      updatedItem.interestRate = parseFloat(updatedItem.interestRate);
      updatedItem.purchaseDate = toIsoDate(updatedItem.purchaseDate);
      if (updatedItem.maturityDate) {
        updatedItem.maturityDate = toIsoDate(updatedItem.maturityDate);
      } else {
        updatedItem.maturityDate = null;
      }
      delete updatedItem.newType;
      delete updatedItem.interestAmount;
      delete updatedItem.principalAmount;
      delete updatedItem.details;
      delete updatedItem.diffInDays;
      if (updatedItem.bank) {
        updatedItem.bank = extractId(updatedItem.bank);
      }
      if (updatedItem.fund) {
        updatedItem.fund = extractId(updatedItem.fund);
      }
      const response = await this.upsertInvestmentTrans({
        item: updatedItem,
        baseCrudKey: this.baseCrudKey,
      });
      this.handleLoadCRUDList();
      this.setItem([this.baseCrudKey, response]);
      this.editFeesDialog = true;
      return response;
    },
    async deleteInvestment() {
      const itemVal = this.item(this.baseCrudKey);
      if (window.confirm('Are you sure you want to delete this record/s?')) {
        const { baseCrudKey } = this;
        const deleteBankObj = { _id: itemVal._id };
        await this.delinvestmentTran({ item: deleteBankObj, baseCrudKey }).then(() => {
          this.setDefaultSelectedItems();
        }).catch((e) => {
          console.warn(e);
          this.setDefaultSelectedItems();
        });
        this.setItems([this.baseCrudKeyBelow, []]);
      }
    },
  },
};
</script>
